import { EventObject } from '@xstate/store-react';
import { StoreContext } from '../../../models/store/context';
import { StoreEvent } from '../../../enums/storeEvent';
import { RegistriaConciergeResponse } from '../../../models/services/api/postRegistria';
import { log } from '@domgen/shared/utils/log';

/**
 * Stores concierge payload on confirmation state.
 *
 * @param context Current store context.
 * @param event Event containing concierge response data.
 * @returns Updated context with concierge data.
 */
export const setConciergeData = <T extends EventObject = EventObject>(
  context: StoreContext,
  event: T & { data: RegistriaConciergeResponse },
): StoreContext => {
  log.debug({ message: StoreEvent.SET_CONCIERGE_DATA, data: event.data });
  return {
    ...context,
    confirmation: {
      ...context.confirmation,
      conciergeData: event.data,
    },
  };
};
